import _isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import lowerCase from 'lodash/lowerCase';
import upperFirst from 'lodash/upperFirst';

// Field names hold underscores too, so the code is read off the end.
const ERROR_CODE = /_(field_required|required|(?:email|e164|url)_invalid|invalid|Invalid value, validation failed on the '\w+' rule)$/;

const ruleOf = code => {
    const rule = /'(\w+)' rule$/.exec(code)?.[1] || code.replace(/^field_|_invalid$/g, '');
    return rule.startsWith('required') ? 'required' : rule;
};

export function parseV4FieldError(text) {
    const match = ERROR_CODE.exec(text);
    if (!match) return { detail: text };
    const path = text.slice(0, match.index);
    const item = /^[^.[]+\[(\d+)\]/.exec(path)?.[1];
    return {
        field: path.split(/[.[]/)[0],
        rule: ruleOf(match[1]),
        ...(item === undefined ? {} : { item: +item }),
    };
}

// The fields an editor can mark itself; any other goes in the action's alert.
export const EDITOR_FIELDS = {
    email: { recipients: 'recipients', subject: 'subject', text: 'text' },
    sms_message: { recipients: 'recipients', body: 'text' },
    voice_message: { recipients: 'recipients', text: 'text' },
    text_message_on_device: { message: 'text', text: 'text' },
    send_assistance_request: { name: 'name', message: 'text' },
    call_webhook: { url: 'url' },
    multi_tenant: { text: 'text' },
    send_telegram_message: { text: 'text' },
};

const FIELD_LABELS = {
    recipients: 'recipients',
    language: 'language',
    originator: 'originator',
    team_id: 'team',
    interval: 'interval',
    duration: 'duration',
    action: 'action',
};

const MESSAGES = {
    required: ['requiredField', 'This field is required'],
    email: ['emailInvalid.error', 'This is not an email address'],
    e164: ['invalidPhoneNumber', 'This is not a valid phone number'],
    url: ['linkInvalid', 'This is not a valid URL'],
    name: ['nameInvalid.error', 'This is not a valid name'],
    invalid: ['scenarioFieldInvalid', 'This value is not valid'],
};

export function v4FieldErrorMessage(t, error) {
    // An empty list fails `min`, not `required`.
    const rule = 'value' in error && isEmpty(error.value) ? 'required' : error.rule;
    return t(...(MESSAGES[rule] || MESSAGES[error.field] || MESSAGES.invalid));
}

const humanize = text => upperFirst(lowerCase(text));

// A mark goes once its field changes: the refusal was about the old value.
export function actionFieldErrors(t, errors, config) {
    const out = { fieldErrors: {}, refusedRecipients: [], messages: [] };
    (errors || []).forEach(error => {
        if (error.detail) {
            out.messages.push(humanize(error.detail));
        } else if (!error.editorField) {
            const label = FIELD_LABELS[error.field] ? t(FIELD_LABELS[error.field]) : humanize(error.field);
            out.messages.push(`${label}: ${v4FieldErrorMessage(t, error)}`);
        } else if (_isEqual(config?.[error.editorField], error.value)) {
            out.fieldErrors[error.editorField] = v4FieldErrorMessage(t, error);
            out.refusedRecipients.push(...(error.refused || []));
        }
    });
    return out;
}
